<section class="page-hero page-hero-content" aria-labelledby="content-page-title">
  <div>
    <h1 id="content-page-title">Content</h1>
  </div>
  <p>Project videos, event galleries, and social updates from Pavillion Properties in one place.</p>
</section>

<section class="section youtube-channel-section" aria-label="Pavillion Properties YouTube channel">
  <div class="iframely-channel-frame">
    <iframe
      src="https://iframely.net/vXeTS3HY?theme=dark"
      title="Pavillion Properties YouTube channel"
      loading="lazy"
    ></iframe>
  </div>
</section>

<section class="section gallery-section" aria-labelledby="gallery-title">
  <div class="gallery-heading">
    <div>
      <p class="section-kicker"><span></span>Gallery</p>
      <h2 id="gallery-title">Events, site moments, and latest social feeds.</h2>
    </div>
    <div class="gallery-tabs" role="tablist" aria-label="Content gallery tabs">
      <button
        type="button"
        [class.active]="contentTab === 'events'"
        (click)="contentTabSelected.emit('events')"
      >
        Events
      </button>
      <button
        type="button"
        [class.active]="contentTab === 'instagram'"
        (click)="contentTabSelected.emit('instagram')"
      >
        Instagram feed
      </button>
      <button
        type="button"
        [class.active]="contentTab === 'youtube'"
        (click)="contentTabSelected.emit('youtube')"
      >
        YouTube feed
      </button>
    </div>
  </div>

  @if (contentTab === 'events') {
    <div class="event-card-grid" aria-label="Event gallery preview">
      <article class="event-card">
        <img src="/kAuAbsdJ0RTn2ohlfsU2M6H9mg_4.jpeg" alt="Pavillion buyer engagement event" />
        <div>
          <span>Buyer event</span>
          <h3>Buyer conversations</h3>
          <p>Guided sessions for project questions, viewing plans, and ownership next steps.</p>
        </div>
      </article>
      <article class="event-card">
        <img
          src="/8NxoJTuIiw8YEBZU0idwISohqEg_3.jpeg"
          alt="Pavillion apartment bedroom showcase"
        />
        <div>
          <span>Show unit</span>
          <h3>Interior showcase</h3>
          <p>Room-by-room moments from Pavillion apartment finishes and staged residences.</p>
        </div>
      </article>
      <article class="event-card">
        <img src="/vcRLLLUSuqK3ajKBz2UBv2SqTo.jpg_2.jpeg" alt="Apartment living room tour" />
        <div>
          <span>Walkthrough</span>
          <h3>Private viewing</h3>
          <p>On-site tours for buyers comparing layouts, amenities, and availability.</p>
        </div>
      </article>
    </div>
  } @else if (contentTab === 'instagram') {
    <div class="instagram-embed-shell instagram-embed-only">
      <iframe
        src="https://www.instagram.com/p/DYPAeYdlUkD/embed"
        title="Latest Pavillion Properties Instagram post"
        loading="lazy"
        allowtransparency="true"
        allow="encrypted-media"
      ></iframe>
    </div>
  } @else {
    <div class="youtube-feed-panel">
      @if (youtubeLoading) {
        <div class="insights-state compact">
          <h3>Loading YouTube videos</h3>
          <p>Fetching the latest channel uploads from Django.</p>
        </div>
      } @else if (youtubeError) {
        <div class="insights-state compact">
          <h3>YouTube videos are unavailable</h3>
          <p>Please open the Pavillion channel directly.</p>
        </div>
      } @else if (youtubeVideos.length) {
        <div class="youtube-video-grid">
          @for (video of youtubeVideos; track video.video_id) {
            <a class="youtube-video-card" [href]="video.url" target="_blank" rel="noopener">
              <span class="youtube-video-thumb">
                @if (video.thumbnail_url) {
                  <img [src]="video.thumbnail_url" [alt]="video.title" />
                }
                <span class="youtube-play-badge" aria-hidden="true">
                  <svg class="material-icon" focusable="false" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </span>
              <span class="youtube-video-copy">
                <span>{{ videoDateLabel(video) }}</span>
                <h3>{{ video.title }}</h3>
                @if (video.description) {
                  <p>{{ video.description }}</p>
                }
              </span>
            </a>
          }
        </div>
      } @else {
        <div class="insights-state compact">
          <h3>No YouTube videos found</h3>
          <p>The channel feed did not return public uploads.</p>
        </div>
      }
    </div>
  }
</section>

<section class="section purchase-strip" aria-labelledby="content-cta-title">
  <div>
    <p class="section-kicker"><span></span>Stay connected</p>
    <h2 id="content-cta-title">Want a walkthrough, event invite, or project media pack?</h2>
  </div>
  <button class="primary-button dark-button" type="button" (click)="inquiryRequested.emit()">
    Send a request
  </button>
</section>
